export default {
    data: () => ({
        additionals: {},
        form: {},
        loaded: false,
        model: {},
    }),
    methods: {
        async load(promise, responseInterceptor = null) {

            const response = await promise

            if (typeof responseInterceptor === 'function') {

                responseInterceptor(response)
            }

            const itens = ['additionals', 'form', 'model']

            itens.forEach(item => (item in response.data) && (this[item] = response.data[item]))

            this.loaded = true
        }
    }
}